export default "__VITE_ASSET__tHbHYqui__"